import React from 'react';
import BasicInfoFields from './BasicInfoFields';
import ImageUploadField from './ImageUploadField';
import StockWeightFields from './StockWeightFields';
import ProductOptionsFields from './ProductOptionsFields';
import FormActions from './FormActions';

export interface ProductFormData {
  name: string;
  description: string;
  image_url: string;
  stock: number;
  weight: number;
  is_active: boolean;
  is_no_prize: boolean;
}

interface ProductFormProps {
  formData: ProductFormData;
  formErrors: Partial<Record<keyof ProductFormData, string>>;
  isEditing: boolean;
  isSubmitting: boolean;
  selectedFile: File | null;
  imagePreview: string;
  onInputChange: (field: keyof ProductFormData, value: string | number | boolean) => void;
  onFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveImage: () => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}

const ProductForm: React.FC<ProductFormProps> = ({
  formData,
  formErrors,
  isEditing,
  isSubmitting,
  selectedFile,
  imagePreview,
  onInputChange,
  onFileSelect,
  onRemoveImage,
  onSubmit,
  onCancel
}) => {
  const handleBasicInfoChange = (field: 'name' | 'description', value: string) => {
    onInputChange(field, value);
  };

  const handleStockWeightChange = (field: 'stock' | 'weight', value: number) => {
    onInputChange(field, value);
  };

  const handleOptionsChange = (field: 'is_active' | 'is_no_prize', value: boolean) => {
    onInputChange(field, value);
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="grid grid-cols-1 gap-4">
        <BasicInfoFields
          name={formData.name}
          description={formData.description}
          errors={{
            name: formErrors.name,
            description: formErrors.description
          }}
          onChange={handleBasicInfoChange}
        />

        <ImageUploadField
          imagePreview={imagePreview}
          selectedFile={selectedFile}
          onFileSelect={onFileSelect}
          onRemoveImage={onRemoveImage}
        />

        <StockWeightFields
          stock={formData.stock}
          weight={formData.weight}
          errors={{
            stock: formErrors.stock,
            weight: formErrors.weight
          }}
          onChange={handleStockWeightChange}
        />

        <ProductOptionsFields
          isActive={formData.is_active}
          isNoPrize={formData.is_no_prize}
          onChange={handleOptionsChange}
        />
      </div>

      <FormActions
        isEditing={isEditing}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        onSubmit={() => {}}
      />
    </form>
  );
};

export default ProductForm;
